<template>
  <div>
    <div v-for="(fileType, aKey) in availableFileTypes" :key="'a'+aKey">
      <v-row class="pa-2">
        <v-col cols="12" class="d-block">
          <h3>
            {{ fileType }}
          </h3>
          <v-divider />
        </v-col>
        <v-col cols="12" md="6" lg="4" xl="3" class="d-flex">
          <v-card width="100%">
            <v-card-text>
              <dropzone v-model="uploadForm.files" height="210px" />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn flat color="primary" @click="submit(fileType)">
                speichern
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col v-for="(fileResource , fKey) in availableFileResources[fileType]" :key="'l'+fKey" cols="12" md="6" lg="4" xl="3" class="d-flex" style="overflow-y:auto">
          <v-card class="image-card" :height="rowHeight" width="100%" @click.stop="downloadFile(fileResource.download_url)">
            <v-card-text height="100%" class="d-flex justify-center image">
              <v-icon large color="secondary" class="close-icon" @click.stop="showDeleteFile(fileResource)">
                mdi-close
              </v-icon>
              <v-icon x-large color="primary">
                <!-- <v-img :src="fileResource.url" /> -->
                {{ getIcon(fileResource) }}
              </v-icon>
            </v-card-text>
            <v-card-title class="image-title">
              {{ fileResource.name }}
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-dialog v-model="deleteFilePrompt" width="400px">
      <v-card>
        <v-card-title>
          Datei entfernen
        </v-card-title>
        <v-card-text>
          Wollen Sie die Datei <b>{{ fileToDelete.name }}</b> entfernen ?
        </v-card-text>
        <v-divider />
        <v-card-actions class="d-flex justify-end">
          <v-btn color="primary" text>
            Abbrechen
          </v-btn>
          <v-btn color="secondary" text @click="deleteFile">
            Entfernen
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Dropzone from '@/Components/Dropzone'
import axios from 'axios'
export default {
   name: 'FileManager',
   components: {
      Dropzone
   },
   props: {
      availableFileTypes: {
         required: true,
         type: Array,
         default: () => {
            return ['Rechnungen', 'Bestellungen']
         }
      },
      modelType: {
         required: true,
         type: Object,
         default: () => {
            return {
               id: 0,
               model: 'Order',

            }
         }
      },
      rowHeight: {
         type: String,
         default: '300px'
      }

   },
   data: function () {
      return {
         availableFileResources: [],
         icons: [
            { type: 'pdf', icon: 'file-pdf-box' },
            { type: 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', icon: 'microsoft-excel' },
            { type: 'xlsx', icon: 'microsoft-excel' },
            { type: 'csv', icon: 'file-delimited' },
            { type: 'vnd.ms-excel', icon: 'file-delimited' },
         ],
         deleteFilePrompt: false,
         fileToDelete: {},
         uploadForm: this.$inertia.form(
            {
               files: [],
               modelData: this.modelType,
               type: null
            }
         ),
      }
   },
   watch: {
      modelType: {
         handler () {
            this.getAvailableFiles()
         },
         deep: true

      }
   },
   mounted () {
      this.getAvailableFiles()
   },
   methods: {
      showDeleteFile (fileResource) {
         this.fileToDelete = fileResource
         this.deleteFilePrompt = true
      },
      deleteFile () {
         this.$inertia.patch(this.route('files.delete', { file: this.fileToDelete })).then(response => {
            this.getAvailableFiles()
            this.deleteFilePrompt = false
         })
      },
      downloadFile (file) {
         window.open(this.route('files.download', { file: file })).focus()
      },
      getIcon (file) {
         let icon = 'mdi-file'
         for (const key in this.icons) {
            if (file.name.includes(this.icons[key].type)) {
               icon = 'mdi-' + this.icons[key].icon
               break
            }
         }
         return icon
      },
      getAvailableFiles () {
         axios.post(this.route('api.files.resources'), {
            types: this.availableFileTypes,
            modelData: this.modelType,
         }).then(response => {
            this.availableFileResources = response.data
         })
      },
      submit (fileType) {
         this.uploadForm.type = fileType
         this.uploadForm.post(this.route('files.upload'), { preserveState: true })
      }
   }
}
</script>

<style scoped>
    .image-title{
        z-index: 1;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-top: 3px solid rgba(255, 255, 255, 0.55);
        background-color: rgba(0, 0, 0, 0.55);
        color: rgba(255, 255, 255, 0.55);
    }
    .image-card:hover .image-title{
        border-top: 3px solid rgba(255, 255, 255, 0.70);
        background-color: rgba(0, 0, 0, 0.70);
        color: rgba(255, 255, 255, 0.70);
    }
    .image{
        margin-top: 40%;
    }
    .close-icon{
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 1;
    }

</style>
